module.exports = __webpack_public_path__ + "img/電気回路_1_2.631d02d2.png";